import React from "react";

export const Marquee = ({ words, className = "" }) => {
  const content = words.join("  ·  ");
  return (
    <div className={`overflow-hidden py-8 border-y border-border select-none ${className}`}>
      <div className="marquee-track">
        <span className="font-display italic text-5xl md:text-7xl text-foreground/80 whitespace-nowrap pr-16">{content}  ·  </span>
        <span className="font-display italic text-5xl md:text-7xl text-foreground/80 whitespace-nowrap pr-16">{content}  ·  </span>
      </div>
    </div>
  );
};
